export default {
  balances: (state) => state.balances,
  commission: (state) => state.commission,
  delegations: (state) => state.delegations,
  delegationsNextKey: (state) => state.delegationsPagination?.next_key,
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAddingTxs: (state) => state.isAddingTxs,
  rewards: (state) => state.rewards,
  transactions: (state) => state.transactions,
  transactionsOffset: (state) => state.transactionsOffset,
  transactionsTotal: (state) => {
    const total = state.transactionsPagination?.total;
    return total ? parseInt(total, 10) : 0;
  },
  unbondings: (state) => state.unbondings,
  unbondingsNextKey: (state) => state.unbondingsPagination?.next_key,
};
